<template>
  <ReticlePicker />
  <ExtraOptionPicker />
  <PlatformPicker />
</template>

<script setup>
import PlatformPicker from "../../commonpickers/PlatformPicker.vue";
import ReticlePicker from "../pickers/ReticlePicker.vue";
import ExtraOptionPicker from "../pickers/ExtraOptionPicker.vue";
const gameStore = useGameStore();
const checkoutStore = useCheckoutStore();

const handleDetails = () => {
  checkoutStore.clearCheckout();
  const firstWeapon = gameStore.getGamePack.prices[0];
  checkoutStore.setPlatform({
    platform: 1,
  });
  checkoutStore.setDetails({
    items: [firstWeapon.id],
  });
  checkoutStore.setGameAndPack({
    game: gameStore.getGame.id,
    pack: gameStore.getGamePack.id,
    fullGame: gameStore.getGame,
    fullPack: gameStore.getGamePack,
  });
};

handleDetails();

onNuxtReady(() => {
  checkoutStore.setCalculating();
});
</script>
